import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { FB_LOCALE, PAGE_ID } from './Facebook.constants';
import messages from './Facebook.messages';
import MessengerCustomerChat from 'react-messenger-customer-chat';

class Facebook extends React.PureComponent<{} & WrappedComponentProps> {
  render = () => (<MessengerCustomerChat
    xfbml={true}
    version="8.0"
    pageId={PAGE_ID}
    appId=''
    autoLogAppEvents={true}
    greetingDialogDisplay="hide"
    language={FB_LOCALE[this.props.intl.locale]}
    loggedInGreeting={this.props.intl.formatMessage(messages.greeting)}
    loggedOutGreeting={this.props.intl.formatMessage(messages.greeting)}
  />);
}

export default injectIntl(Facebook);
